import { beautifyName } from '@/utils/beautifyNames';

export const filterCall = call => {
  const {
    id,
    atendimentoId,
    usuarioRemetente: {
      profissional: { sexo, nome, urlFoto },
    },
    valorRepasseFmt,
    valorRepasse,
    tipoChamada,
  } = call;

  const getDrName = (name, gender = 'M') =>
    `Dr${gender === 'F' ? 'a' : ''}. ${beautifyName(name)}`;

  return {
    id,
    treatmentId: atendimentoId,
    callType: tipoChamada,
    senderName: getDrName(nome, sexo),
    photoUrl: urlFoto,
    value: valorRepasse,
    formatedValue: valorRepasseFmt,
  };
};

export const isRecipient = msg => msg?.tipoCliente === 'DESTINATARIO';
